import { render, staticRenderFns } from "./FCopyBtn.vue?vue&type=template&id=51b6a0cc&"
import script from "./FCopyBtn.vue?vue&type=script&lang=ts&"
export * from "./FCopyBtn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports